import { SVGAttributes } from "react";

export function DataroomFileUploadIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
      <path
        fill="#303239"
        d="M14.45 2.319a3.618 3.618 0 00-2.575-1.069h-6.25A3.125 3.125 0 002.5 4.375v11.25a3.125 3.125 0 003.125 3.125h8.75a3.125 3.125 0 003.125-3.125v-8.75A3.657 3.657 0 0016.431 4.3L14.45 2.319zm-1.95.269c.069.016.136.039.2.068.1.032.197.076.288.132l.15.087c.15.09.289.2.412.325l1.981 1.981c.063.063.119.132.175.2l.107.15c.04.054.075.11.106.169.036.058.067.118.093.181.048.096.086.197.113.3v.069h-3a.625.625 0 01-.625-.625V2.581v.007zM14.375 17.5h-8.75a1.875 1.875 0 01-1.875-1.875V4.375A1.875 1.875 0 015.625 2.5h5.625v3.125A1.875 1.875 0 0013.125 7.5h3.125v8.125a1.875 1.875 0 01-1.875 1.875z"
      ></path>
      <path
        fill="#303239"
        fillRule="evenodd"
        d="M9.46 9.669a.469.469 0 01.663 0l1.667 1.666a.469.469 0 01-.663.663l-.867-.866V15a.469.469 0 11-.937 0v-3.868l-.867.866a.469.469 0 11-.662-.663L9.46 9.67z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
